import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Router } from '@angular/router';

import * as _ from 'underscore';

// Service
import { TypeOfIndebtednessListService } from '../../service/type-of-indebtedness-list/type-of-indebtedness-list.service';

@Component({
	selector: 'app-type-of-indebtedness-list',
	templateUrl: './type-of-indebtedness-list.component.html',
	providers: [
		TypeOfIndebtednessListService,
		HttpModule
	]
})
export class TypeOfIndebtednessListComponent implements OnInit {
	private token;
	public indebtednessList: any[] = [];
	public resultCount: number = 0;
	public orderby: string = "Tipo";
	public sort: string = "asc";
	public permissoes: any[] = [];
	currentPage: number = 0;
	indebtedness: FormGroup;

	constructor(fb: FormBuilder, private typeOfIndebtednessListService: TypeOfIndebtednessListService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.indebtedness = fb.group({
			'Tipo': '',
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.searchIindebtedness(this.indebtedness.value, 0, false);
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc";
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.searchIindebtedness(this.indebtedness.value, this.currentPage, false);
	}

	searchIindebtedness(value: any, page, isSearch) {
		if (isSearch) {
			this.orderby = "Tipo";
			this.sort = "asc";
			this.currentPage = 0;
		}
		this.typeOfIndebtednessListService.searchIindebtedness(this.token, value.Tipo, value.Ativo, this.orderby, this.sort, page).subscribe(result => {
			if (result.Success) {
				this.indebtednessList = result.Result;
				this.resultCount = result.Count;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		})
	}

	paginar($event: any) {
		this.currentPage = $event;
		this.searchIindebtedness(this.indebtedness.value, $event, false);
	}

}



// WEBPACK FOOTER //
// ./src/app/type-of-indebtedness/component/type-of-indebtedness-list/type-of-indebtedness-list.component.ts